import App from './App.vue'
import { createApp } from 'vue'
import { registerPlugins } from '@/plugins'
import i18n from "./i18n";

const app = createApp(App)

registerPlugins(app)

app.use(i18n).mount('#app')
